import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_API;

// export const getCsrfToken = async () => {
//     try {
//         await axios.get('/sanctum/csrf-cookie');
//     } catch (error) {
//         console.warn('CSRF token fetch failed:', error);
//     }
// };


interface LoginParams {
    registrationNumber: string;
    phone: string;
    deviceName?: string;
}

export const login = async (params: LoginParams) => {
    try {
        // ขอ CSRF token ก่อน (สำหรับ Laravel Sanctum)
        // try {
        //     await axios.get(`${defaultUrl}/sanctum/csrf-cookie`, {
        //         withCredentials: true
        //     });
        // } catch (csrfError) {
        //     console.log('CSRF cookie request failed (continuing anyway):', csrfError);
        // }

        const response = await axios.post(`${baseUrl}/client/auth/login`, {
            registrationNumber: params.registrationNumber,
            phone: params.phone,
            deviceName: params.deviceName || 'web-client'
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            // withCredentials: true // ส่ง cookies เพื่อให้ Laravel จัดการ sessionxz/
        });
        
        return response?.data;
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

export const logout = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${baseUrl}/client/auth/logout`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });
        localStorage.removeItem('token');
        localStorage.removeItem('customerId');
        return response?.data;
    } catch (error) {
        console.error('Logout error:', error);
        localStorage.removeItem('token');
        localStorage.removeItem('customerId');
        throw error;
    }
};
